import { getFormasiBanLayout, getFormasiBanViewHeight } from "./formasiBanLayout";

export function FormasiBan({
  formasi,
  cadangan,
  onClick,
  daftarKodeBan,
  highlightedPosisi = [],
  warningPosisi = [],
  unevenWearPosisi = [],
  onBanHover,
  onBanLeave,
}) {
  const highlightedSet = new Set((Array.isArray(highlightedPosisi) ? highlightedPosisi : [highlightedPosisi]).filter(Boolean));
  const warningSet = new Set((Array.isArray(warningPosisi) ? warningPosisi : [warningPosisi]).filter(Boolean));
  const unevenWearSet = new Set((Array.isArray(unevenWearPosisi) ? unevenWearPosisi : [unevenWearPosisi]).filter(Boolean));
  const { lines, bans } = getFormasiBanLayout(formasi, cadangan);

  const getBanPalette = (id, isMapped, isHighlighted, isWarning) => {
    const isCadangan = String(id || "").startsWith("S-");
    let base = null;
    if (isHighlighted) {
      base = { fill: "#0f1f4f", stroke: "#071033", text: "#eff6ff" };
    } else if (isCadangan) {
      base = isMapped
        ? { fill: "#c17f28", stroke: "#7c4a05", text: "#fff7ed" }
        : { fill: "#f0e2c6", stroke: "#b0894f", text: "#6b4f1d" };
    } else if (isMapped) {
      base = { fill: "#2f6ea3", stroke: "#133f66", text: "#f8fafc" };
    } else {
      base = { fill: "#d7e3f1", stroke: "#8aa0b8", text: "#334155" };
    }
    if (isWarning) {
      return {
        ...base,
        stroke: "#dc2626",
        strokeWidth: 4,
        shadow: "drop-shadow(0 0 6px rgba(244, 114, 182, 0.95))",
      };
    }
    return base;
  };

  const emitBanHover = (id, event) => {
    if (typeof onBanHover !== "function") return;
    const pos = String(id || "").trim();
    if (!pos) return;
    const idBan = Number(daftarKodeBan?.[pos] || 0);
    if (!idBan) return;
    onBanHover({
      owner: "mt1",
      pos,
      id_ban: idBan,
      x: Number(event?.clientX || 0),
      y: Number(event?.clientY || 0),
    });
  };

  const Ban = ({ x, y, label, id, w = 60, h = 100, rx = 16, ry = 16 }) => {
    const isMapped = Boolean(daftarKodeBan?.[id]);
    const isHighlighted = highlightedSet.has(id);
    const isWarning = warningSet.has(id);
    const isUnevenWear = unevenWearSet.has(id);
    const palette = getBanPalette(id, isMapped, isHighlighted, isWarning);
    return (
      <g
        onClick={() => (typeof onClick === "function" ? onClick(id) : null)}
        style={{ cursor: "pointer" }}
        onMouseEnter={(e) => emitBanHover(id, e)}
        onMouseMove={(e) => emitBanHover(id, e)}
        onMouseLeave={() => (typeof onBanLeave === "function" ? onBanLeave() : null)}
        data-ban-hover="1"
      >
        <rect
          x={x}
          y={y}
          width={w}
          height={h}
          rx={rx}
          ry={ry}
          fill={palette.fill}
          stroke={palette.stroke}
          strokeWidth={Number(palette?.strokeWidth || 2)}
          style={{ filter: palette?.shadow || "none" }}
        />
        <text
          x={x + w / 2}
          y={y + h / 2 + 5}
          textAnchor="middle"
          dominantBaseline="middle"
          fontSize={w * 0.3}
          fontWeight="bold"
          fill={isUnevenWear ? "#7f1d1d" : palette.text}
          style={{ filter: isUnevenWear ? "drop-shadow(0 0 1px #ffffff) drop-shadow(0 0 2px #ffffff)" : "none" }}
        >
          {label}
        </text>
      </g>
    );
  };

  return (
    <div className="formasi-ban-surface rounded-4">
      <svg
        viewBox={`0 0 420 ${getFormasiBanViewHeight(formasi)}`}
        width="100%"
        height="100%"
        preserveAspectRatio="xMidYMid meet"
        style={{ display: "block" }}
      >
        {lines.map((line, idx) => (
          <line key={`ln-${idx}`} stroke="#8ea6c1" strokeWidth={8} {...line} />
        ))}
        {bans.map((ban) => (
          <Ban key={ban.id} {...ban} />
        ))}
      </svg>
    </div>
  );
}
